import { render, staticRenderFns } from "./SelectThemeDropdown.vue?vue&type=template&id=6185ed8f"
import script from "./SelectThemeDropdown.vue?vue&type=script&lang=js"
export * from "./SelectThemeDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports